module.exports = __webpack_public_path__ + "media/images/digital-aafe00806df9dfdfea6bbce02ea54aa6.png";